import { render, staticRenderFns } from "./getwayConfig.vue?vue&type=template&id=6c3bfd32&scoped=true&"
import script from "./getwayConfig.vue?vue&type=script&lang=js&"
export * from "./getwayConfig.vue?vue&type=script&lang=js&"
import style0 from "./getwayConfig.vue?vue&type=style&index=0&id=6c3bfd32&prod&lang=scss&"
import style1 from "./getwayConfig.vue?vue&type=style&index=1&id=6c3bfd32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3bfd32",
  null
  
)

export default component.exports